import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import { motion } from "framer-motion";
import { AuroraBackground } from "@/components/AuroraBackground";
import { FloatingButtons } from "@/components/FloatingButtons";
import { ArrowLeft, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background relative flex items-center justify-center">
      <Helmet>
        <title>Página não encontrada (404) | OP2P ⊶ CRM e Agentes de IA</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <AuroraBackground />

      <FloatingButtons />
      <div className="relative z-10 text-center px-4">
        <motion.div
          initial={false}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-primary to-accent flex items-center justify-center mx-auto mb-6">
            <Bot className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-8xl font-black gradient-text mb-4">404</h1>
          <p className="text-xl text-muted-foreground mb-2">Página não encontrada</p>
          <p className="text-muted-foreground max-w-md mx-auto">
            Nossos agentes de IA são poderosos, mas não conseguiram encontrar essa página.
          </p>
        </motion.div>

        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Link to="/">
            <Button variant="hero" size="xl" className="group">
              <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
              Voltar para o Início
            </Button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;